var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueSearchs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7465 7.44051L8.92735 6.44089C9.3104 5.50141 9.38147 4.46733 9.11383 3.46795C8.79114 2.26364 8.02197 1.25614 6.94803 0.631193C5.87424 0.00621078 4.62431 -0.161589 3.42827 0.158889C2.23238 0.479328 1.23366 1.24965 0.616225 2.3278C-0.658356 4.55363 0.108105 7.4141 2.32476 8.70415C3.39859 9.32928 4.64867 9.49704 5.84456 9.1766C6.83689 8.91057 7.68967 8.33147 8.30519 7.52729L10.1243 8.52691C10.2736 8.61393 10.4438 8.63184 10.598 8.59053C10.7522 8.54922 10.8906 8.44861 10.9764 8.29859C11.1483 7.99863 11.0453 7.61433 10.7465 7.44051ZM2.94693 7.61775C1.3269 6.67484 0.766893 4.58427 1.69823 2.95756C2.14954 2.16973 2.87946 1.60672 3.75347 1.37253C4.62762 1.1383 5.54111 1.26096 6.32587 1.71759C7.11066 2.17437 7.67283 2.91071 7.90867 3.79087C8.14454 4.67118 8.02583 5.58981 7.57456 6.37778C7.1233 7.16576 6.39352 7.72873 5.51937 7.96296C4.64536 8.19715 3.73172 8.07453 2.94693 7.61775Z",
    fill: "#0087FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSearchs);
export default __webpack_public_path__ + "static/media/blue-searchs.d922a2ac6a5981a2fde546553b71f038.svg";
export { ForwardRef as ReactComponent };